<div id="lista" class="page-layout carded fullwidth">

        <!-- TOP BACKGROUND -->
        <div class="top-bg accent"></div>
        <!-- / TOP BACKGROUND -->
    
        <!-- CENTER -->
        <div class="center">
    
            <!-- HEADER -->
            <div class="header accent"
                    fxLayout="column" fxLayoutAlign="center center"
                    fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">
    
                <!-- APP TITLE -->
                <div class="logo mb-24 mb-md-0"
                        fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="logo-icon s-32 mr-16">
                        business
                    </mat-icon>
                    <span class="logo-text h1">
                        Total de Incosistências
                    </span>
                </div>
                <!-- / APP TITLE -->   
    
                 <div class="add-product-button mb-24 mb-md-0" fxLayout="row" fxLayoutAlign="start center">
                    
                    <button mat-raised-button mat-icon-button [matMenuTriggerFor]="animals">
                        <mat-icon>settings_applications</mat-icon>
                    </button>
                    
                    <mat-menu #animals="matMenu">
                        <button mat-menu-item (click)="openFiltro()">
                            <mat-icon>search</mat-icon>
                            CONSULTAR INCOSISTÊNCIAS
                        </button>
                        <!--
                        <button mat-menu-item (click)="getAllExport()">
                            <mat-icon>cloud_download</mat-icon>
                            EXPORTAR INCOSISTÊNCIAS
                        </button>
                        -->
                    </mat-menu>
                </div>               
    
            </div>
            <!-- / HEADER -->

            <div class="content-card">
                    <!-- CONTENT -->
                <div class="content">
                    <form name="productForm" class="product w-100-p" fxLayout="column" fxFlex>
                        <mat-tab-group (selectedTabChange)="onLinkClick($event)">
                            <mat-tab>
                                <ng-template matTabLabel>                                    
                                    <span matBadge="{{ length }}" matBadgeColor="warn">Custódia Negativas</span>
                                </ng-template>

                                <div class="tab-content p-24" fusePerfectScrollbar fxLayout="column">
                                    <!-- CONTENT CARD -->
                                    <div class="content-card">
                                        <ngx-datatable 
                                            #table 
                                            class='material' 
                                            [loadingIndicator]="loadingIndicator"
                                            [columns]="columns" 
                                            [columnMode]="'force'" 
                                            [headerHeight]="50"                       
                                            [footerHeight]="50" 
                                            [rowHeight]="'auto'"
                                            (sort)="onSort($event)" 
                                            [rows]='rows'>
                            
                                            <ngx-datatable-column name="Conta" prop="numero_xp" [sortable]="false">
                                                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                                    <span style="cursor: pointer;" (click)="redirecionaCliente(row.cliente.id)">
                                                        <b>{{row.cliente.numero_xp}}</b>
                                                    </span>
                                                </ng-template>
                                            </ngx-datatable-column>
                            
                                            <ngx-datatable-column name="Cliente" prop="cliente" [sortable]="true">
                                                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                                    {{row.cliente.nome}}
                                                </ng-template>
                                            </ngx-datatable-column>
                            
                                            <ngx-datatable-column name="Assessor" prop="assessor" [sortable]="true" *ngIf='user.role_id != 5'>
                                                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                                    {{row.cliente.assessor.name}}
                                                </ng-template>
                                            </ngx-datatable-column>
                            
                                            <ngx-datatable-column name="Escritório" prop="escritorio" [sortable]="true" *ngIf='user.role_id != 5'>
                                                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                                    {{row.cliente.escritorio.nome_fantasia}}
                                                </ng-template>
                                            </ngx-datatable-column>
                            
                                            <ngx-datatable-column name="Ativo" prop="ativo" [sortable]="true">
                                                <ng-template let-rowIndex="rowIndex" let-ativo="value" ngx-datatable-cell-template>
                                                    {{ativo.sigla}}
                                                </ng-template>
                                            </ngx-datatable-column>
                            
                                            <ngx-datatable-column name="Qtd" prop="qtd" [sortable]="true">
                                                <ng-template let-rowIndex="rowIndex" let-qtd="value" ngx-datatable-cell-template>
                                                    {{ qtd }} 
                                                </ng-template>
                                            </ngx-datatable-column>
                            
                                        </ngx-datatable>
                            
                                        <div style="padding: 5px 10px">
                                            <mat-paginator 
                                                #paginator 
                                                [length]="length"
                                                [pageSize]="pageSize"
                                                [pageSizeOptions]="pageSizeOptions"
                                                (page)="pageEvent($event)">
                                            </mat-paginator>
                                        </div>
                                    </div>
                                </div>
                            </mat-tab>
                            <mat-tab>
                                <ng-template matTabLabel>                                    
                                    <span matBadge="{{ lengthOpcao }}" matBadgeColor="warn">Opção sem ativo</span>
                                </ng-template>
    
                                <div class="tab-content p-24" fusePerfectScrollbar fxLayout="column">
                                    <!-- CONTENT CARD -->
                                    <div class="content-card">
                                        <ngx-datatable 
                                            #table 
                                            class='material' 
                                            [loadingIndicator]="loadingIndicator"
                                            [columns]="columns" 
                                            [columnMode]="'force'" 
                                            [headerHeight]="50"                       
                                            [footerHeight]="50" 
                                            [rowHeight]="'auto'"
                                            (sort)="onSortOpcao($event)" 
                                            [rows]='rowsOpcao'>
                            
                                            <ngx-datatable-column name="Conta" prop="numero_xp" [sortable]="false">
                                                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                                    <span style="cursor: pointer;" (click)="redirecionaCliente(row.cliente.id)">
                                                        <b>{{row.cliente.numero_xp}}</b>
                                                    </span>
                                                </ng-template>
                                            </ngx-datatable-column>
                            
                                            <ngx-datatable-column name="Cliente" prop="cliente" [sortable]="true">
                                                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                                    {{row.cliente.nome}}
                                                </ng-template>
                                            </ngx-datatable-column>
                            
                                            <ngx-datatable-column name="Assessor" prop="assessor" [sortable]="true" *ngIf='user.role_id != 5'>
                                                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                                    {{row.cliente.assessor.name}}
                                                </ng-template>
                                            </ngx-datatable-column>
                            
                                            <ngx-datatable-column name="Escritório" prop="escritorio" [sortable]="true" *ngIf='user.role_id != 5'>
                                                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                                    {{row.cliente.escritorio.nome_fantasia}}
                                                </ng-template>
                                            </ngx-datatable-column>
                            
                                            <ngx-datatable-column name="Ativo" prop="ativo" [sortable]="true">
                                                <ng-template let-rowIndex="rowIndex" let-ativo="value" ngx-datatable-cell-template>
                                                    {{ativo.sigla}}
                                                </ng-template>
                                            </ngx-datatable-column>                            
                                            
                            
                                        </ngx-datatable>
                            
                                        <div style="padding: 5px 10px">
                                            <mat-paginator 
                                                #paginator 
                                                [length]="lengthOpcao"
                                                [pageSize]="pageSizeOpcao"
                                                [pageSizeOptions]="pageSizeOptionsOpcao"
                                                (page)="pageEventOpcao($event)">
                                            </mat-paginator>
                                        </div>
                                    </div>
                                </div>
                            </mat-tab>
                            <mat-tab>
                                <ng-template matTabLabel>                                    
                                    <span matBadge="{{ lengthBoletaPendente }}" matBadgeColor="warn">Operações Pendentes de Boleta</span>
                                </ng-template>
                                <div class="tab-content p-24" fusePerfectScrollbar fxLayout="column">
                                    <lista-boleta-pendente
                                        (quantidadeBoletas)="getQtdBoletasPendetes($event)" 
                                    >
                                    </lista-boleta-pendente>
                                </div>
                            </mat-tab>
                        </mat-tab-group>
                    </form>
                </div>
            </div>              
        </div>
    </div>